export const accommodationRecommendation = {
  ACCOMMODATION_RECOMMENDATION: 'accommodationRecommendation',
  ACCOMMODATION_RECOMMENDATION_CTABTN: 'accommodationRecommendation.CTABtn',
  ACCOMMODATION_RECOMMENDATION_SLIDER: 'accommodationRecommendation.slider'
}
